module.exports = __webpack_public_path__ + "static/img/data.495a0b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/data.jpg
// module id = CQ3M
// module chunks = 1